import React, { useEffect, useState } from 'react';
import ShapeFxLogo from './ShapeFxLogo';
import './AnimatedLogo.css';

const AnimatedLogo = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // This timeout triggers the CSS animations after the component mounts
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`animated-logo-container ${isLoaded ? 'loaded' : ''}`}>
      <ShapeFxLogo />
    </div>
  );
};

export default AnimatedLogo;